import { render, staticRenderFns } from "./DialogSaleProduct.vue?vue&type=template&id=6413a152"
import script from "./DialogSaleProduct.vue?vue&type=script&lang=js"
export * from "./DialogSaleProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports